import { T } from '@/components/i18n/message.i18n.component';
import { cn } from '@/lib/utils';
import { loginPageMessages } from '@/pages/login/login.messages';
import Markdown from 'react-markdown';
import CHANGELOG from '../../../../CHANGELOG.MD?raw';
import packageJson from '../../../../package.json';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { useState } from 'react';

export const AppVersion = () => {
  const [open, setOpen] = useState(false);

  const handleOpenChange = () => {
    setOpen(!open);
  };

  const replaceBrackets = (text: string) => {
    if (typeof text !== 'string') {
      return '';
    }
    return text.replace(/\(|\)/g, '');
  };

  return (
    <Popover onOpenChange={handleOpenChange}>
      <PopoverTrigger data-testid="app-version-changelog-trigger">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <p data-testid="app-version-number" className="typo-secondary text-secondary-text px-2 py-1">
          v{packageJson.version}
        </p>
      </PopoverTrigger>
      <PopoverContent
        data-testid="app-version-changelog-content"
        className={cn(
          '[&>ul>li]:mb-2 [&>ul>li]:list-disc [&>ul>li]:ml-4',
          'h-[360px] w-[600px] overflow-scroll [&>h1]:mb-1 [&>h2]:mb-2',
          'flex flex-col space-y-2',
        )}
      >
        {!CHANGELOG && (
          <div className="flex flex-1 justify-center items-center">
            <p>
              <T {...loginPageMessages.changelogError} />
            </p>
          </div>
        )}
        {CHANGELOG && (
          <Markdown
            components={{
              a(props) {
                return props.children as string;
              },
              li(props) {
                if (!props.children) return;
                let text = '';
                for (const child of props.children as string[]) {
                  if (typeof child === 'string') {
                    const parsed = replaceBrackets(child);
                    if (parsed) text += `- ${parsed}`;
                  }
                }
                return <p>{text}</p>;
              },
              h1(props) {
                return <p className="typo-caption-600 uppercase text-xl">{props.children}</p>;
              },
              h3(props) {
                return <p className="font-bold">{props.children}</p>;
              },
            }}
          >
            {CHANGELOG}
          </Markdown>
        )}
      </PopoverContent>
    </Popover>
  );
};
